<template>
  <div class="pageContent labelDelay">
    <div class="container mt3 mb3">
      <div class="columns">
        <div class="column is-7">
          <h1>{{ getText('ld001') }} - {{ data.external_id }}</h1>
          <div>
            <p class="mt1">{{ getText('ld002') }}</p>
            <p>{{ getText('ld003') }}</p>
            <p>{{ getText('ld004') }}</p>
            <p>{{ getText('ld005') }}</p>
          </div>
          <div class="mt2">
            <b-input 
              type="text" 
              v-model="customerEmail" 
              :placeholder="getText('yourEmail', true)"></b-input>
            <b-button :disabled="disableButton" class="bg mr2 mt1" @click.stop="storeEmailAddress()">
              {{ getText('confirm', true) }}
            </b-button>
            <p class="mt1" v-if="emailStored==1">{{ getText('ld006') }}</p>
            <p class="mt1" v-else-if="emailStored==2">{{ getText('ld007') }}</p>
          </div>
        </div>
        <div class="column" v-if="data.items.length>0">
          <ReturnItemSummary :items="data.items" />
        </div>
      </div>
    </div>
  </div>
  </template>

<script>
import ErrorModal from "@/components/Modals/ErrorModal.vue";
import ReturnItemSummary from "@/components/ReturnItemSummary";

export default {
  name: 'LabelDelay',

  components: {
    ReturnItemSummary
  },

  data() {
    return {
      pageText: [],
      generalText: [],
      customerEmail: '',
      emailStored: 0,
      isLoading: false,
    }
  },
  props: [
    'data',
  ],

  computed: {
    
    disableButton()
    {
      let state = true;
      if(this.$tools.validEmail(this.customerEmail))
      {
        state = false;
      }
      return state;
    },
  },

  mounted()
  {
    this.pageText = this.$tools.translatePage();
    this.generalText = this.$tools.translatePage('general');
  },

  methods:
  {
    getText(ref, general = false)
    {
      let txtArray = general == false ? this.pageText : this.generalText;
      if(txtArray.length > 0){
        let t = this.$tools.renderText(txtArray,ref);
        if( t.indexOf('blue561')>-1 == true )
        {
          this.openErrorMessage(t);
        } else
        {
          return t;
        }
      }
    },
    
    openErrorMessage(errorCode)
    {
      this.$buefy.modal.open({
        parent: this,
        component: ErrorModal,
        hasModalCard: true,
        props: {
          errorCode: errorCode
        }
      });
    },

    storeEmailAddress()
    {
      this.isLoading = true;
      let postData = {
        "orderId": this.data.id,
        "email": this.customerEmail,
        "locale": this.$tools.getLocaleName(),
      }

      this.$api.post('/add_email_address.php', postData)
      .then(response => {
        if (response.status == 200)
        { 
          if (response.data.status == 'success') {
            this.emailStored = 1;
          } else {
            this.emailStored = 2;
          }
        }
      }).catch(() => {
          this.openErrorMessage('purple756');
          this.isLoading = false;
        });
    }
  }
}
</script>
